// Module
var code = "<remote-paged-grid-layout title-label-code=\"'processes.histories'\" new-entity-enabled=\"false\" columns=\"columns\" find-page=\"findPage\" sort-info=\"sortInfo\"></remote-paged-grid-layout> ";
// Exports
export default code;